module.exports = __webpack_public_path__ + "images/af8d407d93db8232635a5113f0bb36f9a777b1bb852fe6c11c4b40bc844a6399.svg";